import type { IValue } from './Graph';
import { Type } from './Type';

//////////////////////////////////////////////////////////////

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export function BaseValue(typeName: string) {
  abstract class _BaseValue implements IValue {
    public static readonly Type: Type = new Type(typeName);

    public readonly type: Type = _BaseValue.Type;
  }
  return _BaseValue;
}

export interface IWrapper<T> {
  readonly value: T;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export function WrappingValue<T>(typeName: string) {
  abstract class _WrappingValue extends BaseValue(typeName) implements IWrapper<T> {
    public readonly value: T;

    public constructor(val: T) {
      super();
      this.value = val;
    }
  }
  return _WrappingValue;
}

//////////////////////////////////////////////////////////////

export class StringT extends WrappingValue<string>('DT.StringT') {}
export class BooleanT extends WrappingValue<boolean>('DT.BooleanT') {}
export class NumberT extends WrappingValue<number>('DT.NumberT') {}
export class RangeT extends WrappingValue<[number, number]>('DT.RangeT') {}
export class MapT extends WrappingValue<Map<number, number>>('DT.MapT') {}
export class ArrayT extends WrappingValue<Array<number>>('DT.ArrayT') {}

export class IdentifiersList extends WrappingValue<Array<string>>('DT.IdentifiersList') {}

export enum ETuneFlag {
  DEFAULT = 0,
  USER = 1,
  APPROVED = 2
}
export class TuneFlag extends WrappingValue<ETuneFlag>('DT.TuneFlag') {}

//////////////////////////////////////////////////////////////
